// extracted by mini-css-extract-plugin
module.exports = {"paper":"qr-10x10_paper__2s508","page":"qr-10x10_page__2YqCH","label":"qr-10x10_label__2yMsi","label_unique_id":"qr-10x10_label_unique_id__3MNf8"};